import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import FormRow from '../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../components/common/forms/TextInput/TextInputComponent';
import { DatePickerCell } from '../../../components/common/grid/Cells';
import DatePickerInputComponent from '../../../components/common/forms/DatePickerInput/DatePickerInputComponent';

import styled from 'styled-components';
import { Colors } from '~/src/scss/common/style';

interface Props {
  onSubmit: () => void;
}

export default function ExternalFilter({ onSubmit }: Props): JSX.Element {
  return (
    <WrapperExernalFilter>
      <Formik
        initialValues={{
          gtin: '',
          productionDate: '',
          expiry: '',
        }}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit(values);
        }}
      >
        {({ values, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, errors, touched }) => (
          <form autoComplete="off">
            <FormRow title="Additional filters">
              <FormWrapper
                autoComplete="off"
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '24px' }}
              >
                <TextInputComponent
                  name="gtin"
                  value={values.gtin}
                  onChange={(e) => {
                    handleChange(e);
                    handleSubmit(e);
                  }}
                  cols={4}
                />
                <DatePickerInputComponent
                  name="productionDate"
                  value={values.productionDate}
                  onChange={(e) => {
                    handleChange(e.value);
                    handleSubmit(e.value);
                  }}
                  touched={touched}
                  errors={errors}
                  cols={4}
                />
                <DatePickerInputComponent
                  name="expirationDate"
                  value={values.expirationDate}
                  onChange={(e) => {
                    handleChange(e.value);
                    handleSubmit(e.value);
                  }}
                  touched={touched}
                  errors={errors}
                  cols={4}
                />
              </FormWrapper>
            </FormRow>
          </form>
        )}
      </Formik>
    </WrapperExernalFilter>
  );
}

const FormWrapper = styled.div`
  div {
    margin: 0 5px !important;
  }
`;

const WrapperExernalFilter = styled.div`
width: 100%;
form {
  width: 100%;
  background: rgba(239, 125, 0, 0.09);
  padding: 0 !important;
  border: 2px solid ${Colors.newOrage};
  div {
    width: 100%;
  }
  border-radius: 10px;
`;
